import { Header } from "./Components/Header";
import { Footer } from "./Components/Footer.js";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { Home } from "./Pages/Home.js";
import { SecretariaLogin } from "./Pages/SecretariaLogin.js";
import { Dashboard } from "./Pages/Dashboard.js";
import AdminUsers from "./Pages/AdminUsers.js";
import { AdminProdutos } from "./Pages/AdminProdutos.js";
import { AdminInscricoes } from "./Pages/AdminInscricoes.js";
import { AdminMinistracoes } from "./Pages/AdminMinistracoes.js";
import { AuthProvider } from "./contexts/AuthContext.js";
import { ProtectedRoute } from "./Components/ProtectedRoute.js";
import { AdminRoute } from "./Components/AdminRoute.js";
import { CssBaseline, ThemeProvider } from "@mui/material";
import Announcements from "./Pages/Annoucements.js";
import ContactacoesEscala from "./Pages/ContactacoesEscala.js";
import GerenciarMinistros from "./Pages/GerenciarMinistros.js";
import GerenciarReservas from "./Pages/GerenciarReservas.js";
import { Contato } from "./Pages/Contato.js";
import { Ministracoes } from "./Pages/Ministracoes.js";
import { MinistracacoDetalhes } from "./Pages/MinistracacoDetalhes.js";
import { EventosDetalhes } from "./Pages/EventosDetalhes.js";
import { Eventos } from "./Pages/Eventos.js";
import { NoticiasDetalhes } from "./Pages/NoticiasDetalhes.js";
import { Inscricoes } from "./Pages/Inscricoes.js";
import { InscricoesExclusivas } from "./Pages/InscricoesExclusivas.js";
import MensagensPadrao from "./Pages/MessagensPadrao.js";
import { Sobre } from "./Pages/Sobre.js";
import theme from "./Theme/index.js";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <Router>
          <CssBaseline />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/sobre" element={<Sobre />} />
          <Route path="/contato" element={<Contato />} />
            <Route path="/inscricoes" element={<Inscricoes />} />
            {/* Rota exclusiva, NÃO listada no menu — repassada manualmente */}
            <Route
              path="/inscricoes-exclusivas"
              element={<InscricoesExclusivas />}
            />
            <Route path="/ministracoes" element={<Ministracoes />} />
            <Route
              path="/ministracoes/:id"
              element={<MinistracacoDetalhes />}
            />
            <Route path="/eventos" element={<Eventos />} />
            <Route path="/eventos/:id" element={<EventosDetalhes />} />
            <Route path="/noticias/:id" element={<NoticiasDetalhes />} />
            <Route path="/login" element={<SecretariaLogin />} />
            <Route path="/secretaria-login" element={<SecretariaLogin />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/announcements"
              element={
                <ProtectedRoute>
                  <Announcements />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contactacoes-escala"
              element={
                <ProtectedRoute>
                  <ContactacoesEscala />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ministros"
              element={
                <ProtectedRoute>
                  <GerenciarMinistros />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reservas"
              element={
                <ProtectedRoute>
                  <GerenciarReservas />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mensagens"
              element={
                <ProtectedRoute>
                  <MensagensPadrao />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <AdminRoute>
                  <AdminUsers />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/produtos"
              element={
                <AdminRoute>
                  <AdminProdutos />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/inscricoes"
              element={
                <AdminRoute>
                  <AdminInscricoes />
                </AdminRoute>
              }
            />
            <Route
            path="/admin/ministracoes"
            element={
              <AdminRoute>
                <AdminMinistracoes />
              </AdminRoute>
            }
          />
        </Routes>
          <Footer />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
